<template>
  <v-card class="blue-grey lighten-5">
    <v-overlay :value="!isConnected" absolute />

    <v-card-title
      :class="isConnected ? 'accent--text' : 'secondary--text'"
      class="headline justify-center"
      v-text="playerName"
    />

    <v-card-text class="text-center">
      <div class="white secondary--text rounded subtitle-2 mt-2 py-1">
        <span v-text="$t('animation.ontime.questionOne')" />
        <span> : </span>
        <span v-text="answerOne" />
      </div>

      <div v-if="onQuestionTwo" class="white accent--text rounded subtitle-2 mt-2 py-1">
        <span v-text="$t('animation.ontime.questionTwo')" />
        <span> : </span>
        <span v-text="answerTwo" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PlayerCard',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isConnected () {
      return this.value.playerName
    },
    playerName () {
      return this.isConnected
        ? this.value.playerName
        : this.$t('animation.ontime.notPlayerName')
    },
    playerStatus () {
      return this.value.status
    },
    onQuestionTwo () {
      return ['canAnswerQuestionTwo', 'finished'].includes(this.playerStatus)
    },
    answerOne () {
      const { answerOne } = this.value
      return answerOne
        ? this.$t(`animation.ontime.choiceList.${answerOne}`)
        : this.$t('animation.ontime.noAnswered')
    },
    answerTwo () {
      const { answerTwo } = this.value
      return answerTwo
        ? this.$t(`animation.ontime.choiceList.${answerTwo}`)
        : this.$t('animation.ontime.noAnswered')
    },
  },
}
</script>
